import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '恋爱', href: '/category/romance' },
    { label: '奇幻', href: '/category/fantasy' },
    { label: '热血', href: '/category/action' },
    { label: '剧情', href: '/category/drama' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-heading font-semibold text-foreground-900 whitespace-nowrap">
              韩国漫画网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className={`px-3 py-2 text-sm rounded-md transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.href
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 rounded-full bg-background-100 flex items-center justify-center hover:bg-background-200 transition-colors duration-200 cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600 text-sm w-4 h-4 flex items-center justify-center"></i>
            </button>
            <Link
              to="/category/romance"
              className="bg-primary-500 text-background-50 text-sm px-4 py-2 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 rounded-full bg-background-100 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-600 text-sm w-4 h-4 flex items-center justify-center ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className={`block px-3 py-2.5 text-sm rounded-md transition-colors duration-200 ${
                  location.pathname === link.href
                    ? 'text-primary-500 font-medium bg-primary-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/category/romance"
              className="block text-center bg-primary-500 text-background-50 text-sm px-4 py-2.5 rounded-full mt-2 whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}